import axios from 'axios';
import { getAuthHeader } from './userInfo-actions';
import { academyDataActions } from './academy-slice';
import Cookies from 'js-cookie';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

export const academyInfo = shortName => {
  return async dispatch => {
    let academyData = await axios.post(
      `${process.env.REACT_APP_API_PATH_SLS_ACADEMY}/data`,
      { shortName },
      { headers: getAuthHeader() }
    );
    if (academyData.status === 200) {
      dispatch(
        academyDataActions.info({
          academyData: academyData.data
        })
      );
    }
  };
};

export const getCoursesByAcademy = (
  idEmisor,
  tipoFiltro,
  filter
) => {
  tipoFiltro = tipoFiltro == null ? 0 : tipoFiltro;
  let params = new Object();
  params.idEmisor = idEmisor;
  params.tipoFiltro = tipoFiltro;
  filter ? (params.filter = filter) : null;
  return async dispatch => {
    let coursesData = await axios.get(
      `${process.env.REACT_APP_API_PATH_COURSE}/course`,
      {
        params,
        headers: getAuthHeader()
      }
    );

    if (coursesData.data.httpStatus === 200) {
      dispatch(
        academyDataActions.courses({
          coursesData: coursesData.data
        })
      );
    }
  };
};

export const getMenuAcademy = idAcademy => {
  return async dispatch => {
    let academyMenuData = await axios.post(
      `${process.env.REACT_APP_API_PATH_SLS_ACADEMY}/menus/get`,
      { idAcademy },
      { headers: getAuthHeader() }
    );
    if (academyMenuData.data.httpStatus === 200) {
      dispatch(
        academyDataActions.menu({
          academyMenuData: academyMenuData.data
        })
      );
    }
  };
};

export const getMetadataAcademy = (idProduct, edit) => {
  return async dispatch => {
    let metadataAcademy = await axios.post(
      `${process.env.REACT_APP_API_PATH_GENERAL_JAVA}/metadata/product-metadata`,
      {
        idProduct,
        edit,
        productType: 'ACADEMY'
      },
      { headers: getAuthHeader(jwtCookie) }
    );
    if (metadataAcademy.data) {
      dispatch(
        academyDataActions.metadata({
          metadataAcademy: metadataAcademy.data
        })
      );
      return metadataAcademy.data;
    }
    return false;
  };
};

export const saveMetadataAcademy = async data => {
  let saveData = await axios.post(
    `${process.env.REACT_APP_API_PATH_GENERAL_JAVA}/metadata/save-metadata`,
    data,
    { headers: getAuthHeader(jwtCookie) }
  );
  if (saveData.data.result) {
    return true;
  }
  return false;
};

export const checkCode = async (code, idAcademy) => {
  let checkCodeData = await axios.get(
    `${process.env.REACT_APP_API_PATH_SLS_CODES}/code/check/renewal`,
    {
      params: {
        code,
        idAcademy
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (checkCodeData.data) {
    return true;
  }
  return false;
};

export const renewSuscription = async (code, idAcademy) => {
  let renewSuscription = await axios.post(
    `${process.env.REACT_APP_API_PATH_SLS_CODES}/code/renewal`,
    {
      code,
      idAcademy
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (renewSuscription.data) {
    return true;
  }
  return false;
};
